import { merge } from 'lodash-es';
import { CHART_TYPES } from '../enums';

export default (config, chartJSConfig, context) => {
  const { series } = config;

  const isFunnel = series.every(({ seriesType }) => {
    return seriesType === CHART_TYPES.FUNNEL.toUpperCase();
  });

  if (!isFunnel) {
    return chartJSConfig;
  }

  const configObject = {
    type: 'funnel',
    data: {
      datasets: chartJSConfig.data.datasets.map((dataset, index, array) => {
        return merge(dataset, {
          barPercentage: 0.6,
          categoryPercentage: 1.10,
          borderRadius: 0,
          hidden: false,
          type: CHART_TYPES.BAR
        });
      })
    },
    options: {
      scales: {
        y: {
          ticks: {
            display: false
          },
          grid: {
            display: false
          },
          border: {
            display: false
          },
        },
        x: {
          border: {
            display: false,
          },
          grid: {
            drawBorder: false,
            display: false
          }
        }
      }
    }
  };

  return merge(chartJSConfig, configObject);
};
